// extracted by mini-css-extract-plugin
export default {"overlay":"messageModal_overlay__ni2p5","modalContet":"messageModal_modalContet__BNOb8","buttonBox":"messageModal_buttonBox__x22Cs"};